module.exports = __webpack_public_path__ + "img/wec_logo.3acce722.png";